module.exports = __webpack_public_path__ + "static/media/eighth_veterans_memorial4.a200501e.jpg";